import { Component } from 'react';
import L from 'leaflet';
import EventHandlerMixin from '../mixins/EventHandlerMixin'; // TODO: kill Mixins!
import PropertyHelperMixin from '../mixins/PropertyHelperMixin';
import LeafletComponentMixin from '../mixins/LeafletComponentMixin';
import PropTypes from 'prop-types';

// Lodash
import { get, isFunction, omit } from 'lodash';

// TODO -- Is this class needed? Can it be combined with the inheriting class in
// calling code or something simpler? The structure is left over from ReactLeaflet.

// Brief explanation of this weird class - it does not render the DOM elements for the map, but instead tracks state
// that is expected to affect rendering and tries to get Leaflet to behave as though part of the React lifecycle.
class GeoJsonLayer extends Component {

  constructor(props) {
    super(props);
    this.displayName = 'GeoJsonLayer';
    // Ugly apply of Mixin
    Object.assign(this, EventHandlerMixin);
    Object.assign(this, PropertyHelperMixin);
    Object.assign(this, LeafletComponentMixin);

    this.updatableProps = {
      layerStyle: function (layer) {
        layer.setStyle(this.props.layerStyle);
      },
      geoJson: function (layer) {
        // GeoJson layers don't support direct reset of the data
        // so this is the closest way to do it. Styles also need to be
        // reset because apparently that data is set in the child layers
        // and is lost.
        layer.clearLayers();
        layer.addData(this.props.geoJson);
        layer.setStyle(this.props.layerStyle);

        if (get(this.props.geoJson, 'properties.isSelected')) {
          this.props.map.fire('poly-selected', { layer: this.props.geoJson });
        }
      }
    };
  }

  buildOptions() {
    const options = omit(this.props, ['map', 'geoJson']);
    options.interactive = !!this.props.onSelectPoly;
    if (options.interactive) { options.pane = 'interactive'; }
    return options;
  }

  generateComponent() {
    return L.geoJson(this.props.geoJson, this.buildOptions());
  }

  addToMap(map, component) {
    component.on('click', this._selectPoly, this);

    component.addTo(map);
    // Fire the event on the map for the whole layer (multi polygons will fire
    // several layeradd events)
    map.fire('geojsonlayeradd', { layer: this.props.geoJson });
  }

  _selectPoly(e) {
    L.DomEvent.stopPropagation(e);
    this.props.map.fire('poly-selected', { layer: this.props.geoJson });
    if (isFunction(this.props.onSelectPoly)) {
      this.props.onSelectPoly(e.latlng);
    }
  }

  render() {
    return null;
  }
}

GeoJsonLayer.propTypes = {
  geoJson: PropTypes.object.isRequired,
  layerStyle: PropTypes.any, // attempted React.oneOfType([..object, ..function]) but threw weird errors
  map: PropTypes.object,
  onEachFeature: PropTypes.func,
  onSelectPoly: PropTypes.func // If falsy, indicates that layer is not interactive, affecting ordering of layers.
};

GeoJsonLayer.defaultProps = { layerStyle: {} };

export { GeoJsonLayer };